// extracted by mini-css-extract-plugin
module.exports = {"textAreaBox":"TextArea_textAreaBox__1QHZo","inputPassContainer":"TextArea_inputPassContainer__48Mqj","leftIconBox":"TextArea_leftIconBox__1RAos"};